import Client from './Client'

export default {
    install: (app, options) => {
        let client = new Client();
        app.config.globalProperties.$WebSocket = client;
    }
}